import {
    SEND_ACTION,
    ADD_MAIL,
    PIN_ACTION,
    MESSAGE_ACTION,
    GET_DESTINATION_ACTION,
    SET_DESTINATION_ACTION,
    SAVE_PASS_ACTION,
    SAVE_TYPE_OF_COMPANY,
    ADD_CUIT
} from './constants';

export const sendAction = (payload) => {
    return {
        type: SEND_ACTION,
        payload
    };
}

export const addMailAction = (payload) => {
    return {
        type: ADD_MAIL,
        payload
    }
}

export const addPinAction = (payload) => {
    return {
        type: PIN_ACTION,
        payload
    }
}

export const getMessage = (payload) => {
    return {
        type: MESSAGE_ACTION,
        payload
    }
}

export const getDestination = () => {
    return {
        type: GET_DESTINATION_ACTION
    }
}

export const setDestination = (payload) => {
    return {
        type: SET_DESTINATION_ACTION,
        payload
    }
}

export const savePassAction = (payload) => {
    return {
        type: SAVE_PASS_ACTION,
        payload
    };
}

export const saveTypeCompany = (payload) => {
    return {
        type: SAVE_TYPE_OF_COMPANY,
        payload
    };
}
export const addCuitAction = (payload) => {
    return {
        type: ADD_CUIT,
        payload
    }
}



// WEBPACK FOOTER //
// ./src/conteiners/Step1/accions.js